module.exports = __webpack_public_path__ + "img/badge-list-thumb-074.a59b5ee7.png";